__turbopack_context__.v({
  "className": "moonwalk_79b0afb-module__RL3nxG__className",
  "variable": "moonwalk_79b0afb-module__RL3nxG__variable",
});
